// Odometer-style digits adapted from RhineLabUI's Rolling Number usage
// (@kitlangton/rolling-number, MIT). Three copies allow 9→0 and 0→9
// to move one cell in the expected direction.
const DIGITS = "0123456789".split("");

export function createRollingNumber(element) {
  let length = -1;
  let digits = [];
  let staticCells = [];
  let previous = "";
  let accessible;

  const build = (text) => {
    element.replaceChildren();
    digits = [];
    staticCells = [];
    const fragment = document.createDocumentFragment();
    accessible = document.createElement("span");
    accessible.className = "sr-only";
    fragment.append(accessible);
    for (const char of text) {
      if (/\d/.test(char)) {
        const column = document.createElement("span");
        column.className = "roll-digit";
        column.setAttribute("aria-hidden", "true");
        const strip = document.createElement("span");
        strip.className = "roll-strip";
        strip.innerHTML = DIGITS.concat(DIGITS, DIGITS)
          .map((digit) => `<span>${digit}</span>`).join("");
        column.append(strip);
        fragment.append(column);
        digits.push({ strip, value: null, position: null });
      } else {
        const cell = document.createElement("span");
        cell.className = "roll-static";
        cell.setAttribute("aria-hidden", "true");
        cell.textContent = char;
        fragment.append(cell);
        staticCells.push(cell);
      }
    }
    element.append(fragment);
    length = text.length;
  };

  return (value) => {
    const text = String(value ?? "");
    const direction = /^\d+$/.test(text) && /^\d+$/.test(previous) && text.length === previous.length
      ? Math.sign(text.localeCompare(previous, "en", { numeric: false }))
      : 0;
    if (text.length !== length || text !== previous) {
      if (text.length !== length) build(text);
      previous = text;
      accessible.textContent = text;
    }
    let digit = 0;
    for (const char of text) {
      if (!/\d/.test(char)) continue;
      const cell = digits[digit++];
      if (!cell) continue;
      const target = Number(char);
      if (cell.value === target) continue;
      if (cell.value === null) {
        cell.position = 10 + target;
        cell.strip.style.transition = "none";
        cell.strip.style.transform = `translateY(${-cell.position}em)`;
        void cell.strip.offsetHeight;
        cell.strip.style.transition = "";
        cell.value = target;
        continue;
      }
      let step = target - cell.value;
      if (direction > 0 && step < 0) step += 10;
      else if (direction < 0 && step > 0) step -= 10;
      else if (!direction && Math.abs(step) > 5) step -= Math.sign(step) * 10;
      if (cell.position + step < 0 || cell.position + step >= 30) {
        cell.position = 10 + cell.value;
        cell.strip.style.transition = "none";
        cell.strip.style.transform = `translateY(${-cell.position}em)`;
        void cell.strip.offsetHeight;
        cell.strip.style.transition = "";
      }
      cell.position += step;
      cell.value = target;
      cell.strip.style.transform = `translateY(${-cell.position}em)`;
    }
  };
}
